var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-popup" }, [
    _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: {
          id: "agencyPaymentListModal",
          tabindex: "-1",
          role: "dialog",
          "aria-hidden": "true",
        },
      },
      [
        _c(
          "div",
          {
            staticClass: "modal-dialog modal-dialog-centered",
            attrs: { role: "document" },
          },
          [
            _c("div", { staticClass: "modal-content" }, [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "modal-body" },
                [_c("agency-payments-list")],
                1
              ),
              _vm._v(" "),
              _vm._m(1),
            ]),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c("h3", { staticClass: "title mt-2 ml-2" }, [
        _vm._v("Acente Ödeme Geçmişi"),
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-label": "Close",
          },
        },
        [
          _c("span", {
            staticClass: "la la-close",
            attrs: { "aria-hidden": "true" },
          }),
        ]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-footer border-top-0 pt-0" }, [
      _c(
        "button",
        {
          staticClass: "theme-btn font-weight-bold font-size-15 mr-2",
          staticStyle: { "background-color": "crimson" },
          attrs: { type: "button", "data-dismiss": "modal" },
        },
        [_vm._v("iptal")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }